import React, { createContext, useContext, useState } from 'react';

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
    const [profileId, setProfileId] = useState(() => localStorage.getItem('hm_profile_id') || null);
    const [profileDbId, setProfileDbId] = useState(() => localStorage.getItem('hm_profile_db_id') || null);
    const [firstName, setFirstName] = useState(() => localStorage.getItem('hm_first_name') || null);

    const setProfile = ({ profileId, profileDbId, firstName }) => {
        setProfileId(profileId);
        setProfileDbId(profileDbId);
        if (profileId) localStorage.setItem('hm_profile_id', profileId);
        if (profileDbId) localStorage.setItem('hm_profile_db_id', profileDbId);
        if (firstName !== undefined) {
            setFirstName(firstName);
            if (firstName) localStorage.setItem('hm_first_name', firstName);
        }
    };

    const clearProfile = () => {
        setProfileId(null);
        setProfileDbId(null);
        setFirstName(null);
        localStorage.removeItem('hm_profile_id');
        localStorage.removeItem('hm_profile_db_id');
        localStorage.removeItem('hm_first_name');
    };

    return (
        <ProfileContext.Provider value={{ profileId, profileDbId, firstName, setProfile, clearProfile }}>
            {children}
        </ProfileContext.Provider>
    );
}

export function useProfile() {
    const ctx = useContext(ProfileContext);
    if (!ctx) throw new Error('useProfile must be used within a ProfileProvider');
    return ctx;
}
